// A single approver's sign-off on a report, in `zcc_approvals.status`. The report's
// own status lives in `reportStatuses`, which also carries the outbound pipeline
// states (ready_to_send / sending / sent / done / failed) that never apply to an
// individual sign-off. The two diverge at the sign-off step itself: an approval is
// `approved`, while the report it belongs to becomes `finalised`.
//
// IMPORTANT: The sorting of these statuses here is important for the `field(status, ...)`
// sort over a user's assigned approvals, so inserting mid-list would silently reorder
// dashboards.
export const approvalStatuses = [
  'pending',
  'approved',
  'cancelled',
  'rejected',
] as const;

export const approvalLabels = [
  'Reported by',
  'Authorised by',
] as const;
